/**
 * @fileoverview Shared password policy used by CMS UI, legacy routes, and public API validation.
 */

export default {
  requiredLength: 8,
  requiredScore: 2,
};
